import {
  BankTransferIcon,
  GiftCardIcon,
  OriginalPaymentMethodIcon,
  refundMethods,
  StoreCreditIcon,
} from '@reveni-io/reveni-ui'

export const refundMethodConfig = {
  [refundMethods.bankTransfer]: {
    Icon: BankTransferIcon,
    defaultName: 'Transferencia instantánea',
    instant: {
      defaultCopyKey: 'instantRefundBankTransfer',
      customCopyKey: 'summary.instant_refund.bank_transfer',
    },
    normal: {
      defaultCopyKey: 'instantRefundBankTransfer',
      customCopyKey: 'summary.instant_refund.bank_transfer',
    },
  },
  [refundMethods.originalPaymentMethod]: {
    Icon: OriginalPaymentMethodIcon,
    defaultName: 'Método de pago original',
    instant: {
      defaultCopyKey: 'instantRefundOriginalPaymentMethod',
      customCopyKey: 'summary.instant_refund.original_payment_method',
    },
    normal: {
      defaultCopyKey: 'refundOriginalPaymentMethod',
      customCopyKey: 'summary.refund.original_payment_method',
    },
  },
  [refundMethods.storeCredit]: {
    Icon: StoreCreditIcon,
    defaultName: 'Crédito en tienda',
    instant: {
      defaultCopyKey: 'instantRefundStoreCredit',
      customCopyKey: 'summary.instant_refund.store_credit',
    },
    normal: {
      defaultCopyKey: 'refundStoreCredit',
      customCopyKey: 'summary.refund.store_credit',
    },
  },
  [refundMethods.giftCard]: {
    Icon: GiftCardIcon,
    defaultName: 'Tarjeta regalo',
    instant: {
      defaultCopyKey: 'instantRefundGiftCard',
      customCopyKey: 'summary.instant_refund.gift_card',
    },
    normal: {
      defaultCopyKey: 'refundGiftCard',
      customCopyKey: 'summary.refund.gift_card',
    },
  },
}
